import { Avatar, Box, Drawer, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { IMG_BASE_URL } from "src/config/constants";
import UserInfoDrawer from "./UserInfoDrawer";

export default function UserInfo({ nickname, avatar, mobile, uid, enablePreview = true }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{
          display: 'inline-flex',
          cursor: enablePreview ? "pointer" : "default",
        }}
        onClick={() => {
          if (!enablePreview) return;
          setShow(true);
        }}
      >
        <Avatar alt={nickname} src={`${(avatar || '').startsWith('http') ? '' : IMG_BASE_URL}${avatar}?w=60`} />
        <Stack>
          <Typography variant="subtitle2" noWrap>
            {nickname || mobile}
          </Typography>
          <Typography variant="subtitle2" noWrap>
            {uid}
          </Typography>
        </Stack>
      </Stack>
      {show && <UserInfoDrawer open uid={uid} avatar={avatar} nickname={nickname} onClose={() => setShow(false)} />}
    </>
  );
}
